import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../helpers/reselectHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {ContactDetailsTabsEnum} from '../../../models/api/localPreferencesModel';
import {navigateToContactDetailsFromContactCardAction} from '../../../store/panels/contacts/contactCard/contactCardPanelActions';
import {ContactCardPanelId} from '../../../store/panels/panelStateBase';
import {ContactCardFooterOpenDetails} from './contactCardFooterOpenDetails';

/*
 * Types.
 */

interface ContactCardFooterOpenDetailsContainerProps {
  panelId: ContactCardPanelId;
  card?: CardModel;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<ContactCardFooterOpenDetailsContainerProps>()(
  ({panelId, card}) => ({
    onOpenContactDetails: () =>
      navigateToContactDetailsFromContactCardAction(panelId, ContactDetailsTabsEnum.CONTACT, card),
  }),
);

export const ContactCardFooterOpenDetailsContainer = connect(
  null,
  mapDispatchToProps,
)(ContactCardFooterOpenDetails);
